import {CUSTOM_ELEMENTS_SCHEMA, NgModule} from '@angular/core';
import { CommonModule } from '@angular/common';
import {MatDialogModule} from "@angular/material/dialog";
import { PaymentDialogComponent } from './dialogs/payment-dialog/payment-dialog.component';

import {DropdownMenusModule} from "../../_metronic/partials";
import { NzPaginationModule } from 'ng-zorro-antd/pagination';
import {NzModalModule} from "ng-zorro-antd/modal";
import {UpdateUserCredentialsComponent} from "./components/update-user-credentials/update-user-credentials.component";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import { ConfirmationModalComponent } from './dialogs/confirmation-modal/confirmation-modal.component';
import {CreateUserComponent} from "../../pages/admin/users/create-user/create-user.component";
import { CardLoaderComponent } from './components/card-loader/card-loader.component';
import { AddressFormComponent } from './components/address-form/address-form.component';
import { ErrorMessageModalComponent } from './dialogs/error-message-modal/error-message-modal.component';
import {GoogleMapsModule} from "@angular/google-maps";
import {NzUploadModule} from "ng-zorro-antd/upload";
import {NzIconModule} from "ng-zorro-antd/icon";
import {NzDatePickerModule} from "ng-zorro-antd/date-picker";
import {NzTimePickerModule} from "ng-zorro-antd/time-picker";
import {NzSelectModule} from "ng-zorro-antd/select";
import {LineTruncationDirective, LineTruncationLibModule} from 'ngx-line-truncation';
import {NzSwitchModule} from "ng-zorro-antd/switch";
import {NzAffixModule} from "ng-zorro-antd/affix";
import {DataTablesModule} from "angular-datatables";
import {NzRadioModule} from "ng-zorro-antd/radio";
import { ColorSketchModule } from 'ngx-color/sketch';
import {ClipboardModule} from "ngx-clipboard";
import {NzNotificationModule} from "ng-zorro-antd/notification";
import { UpdatePaymentModalComponent } from './components/update-payment-modal/update-payment-modal.component';
import {NgxStripeModule} from "ngx-stripe";
import { ChangePasswordModalComponent } from './components/change-password-modal/change-password-modal.component';
import { ProvideFeedbackModalComponent } from './components/provide-feedback-modal/provide-feedback-modal.component';
import { CalendarModalComponent } from './components/calendar-modal/calendar-modal.component';
import {CalendarModule} from "angular-calendar";
import {FullCalendarModule} from "@fullcalendar/angular";
import dayGridPlugin from "@fullcalendar/daygrid";
import interactionPlugin from "@fullcalendar/interaction";
import timeGridPlugin from '@fullcalendar/timegrid';
import {NzImageModule} from "ng-zorro-antd/image";
import { FileUploaderComponent } from './components/file-uploader/file-uploader.component';
import { SocialNetworkListComponent } from './components/social-network-list/social-network-list.component';
import { InlineFileUploadComponent } from './components/inline-file-upload/inline-file-upload.component';
import {AutomaticFileUploadComponent} from "./components/automatic-file-upload/automatic-file-upload.component";
import {NzSliderModule} from "ng-zorro-antd/slider";
import {NzPopoverModule} from "ng-zorro-antd/popover";
import {NzAutocompleteModule} from "ng-zorro-antd/auto-complete";
import { NumberFormatPipe } from './pipes/number-format.pipe';
import { NzAnchorModule } from 'ng-zorro-antd/anchor';
import {NgApexchartsModule} from "ng-apexcharts";
import {BrandSelectorComponent} from "./components/brand-selector/brand-selector.component";
import {SearchBrandComponent} from "./components/search-brand/search-brand.component";
import {NzToolTipModule} from "ng-zorro-antd/tooltip";
import { SwiperModule } from 'swiper/angular';
import {TimeagoModule} from "ngx-timeago";
import {AngularEditorModule} from "@kolkov/angular-editor";
import { ConfigureEmailModalComponent } from './dialogs/configure-email-modal/configure-email-modal.component';
import {RouterModule} from "@angular/router";
import { CopyButtonComponent } from './components/copy-button/copy-button.component';
import { MyProfileComponent } from './shared-views/my-profile/my-profile.component';
import {LargeFileUploader} from "./components/large-file-uploader/large-file-uploader.component";
import {NzBreadCrumbModule} from "ng-zorro-antd/breadcrumb";
import {ReportGeoChartComponent} from "./graphs/report-geo-chart/report-geo-chart.component";
import {ReportAgeChartComponent} from "./graphs/report-age-chart/report-age-chart.component";
import {NzDrawerModule} from "ng-zorro-antd/drawer";
import { WelcomeModalComponent } from './wizards/welcome-modal/welcome-modal.component';
import { WelcomeWidgetComponent } from './welcome-widget/welcome-widget.component';
import { EndTrialModalComponent } from './components/end-trial-modal/end-trial-modal.component';
import {FancyCheckboxComponent} from "./components/fancy-checkbox/fancy-checkbox.component";
import {DonationTableComponent} from "./donation-table/donation-table.component";
import {ActivityGraphComponent} from "./activity-graph/activity-graph.component";
import {HeatMapComponent} from "./heat-map/heat-map.component";
import { SearchFiltersComponent } from './components/search-filters/search-filters.component';
import {BsDatepickerModule} from "ngx-bootstrap/datepicker";
import {NzSpinModule} from "ng-zorro-antd/spin";
import {DonorTableComponent} from "./donor-table/donor-table.component";
import { NoCampaignsModalComponent } from './dialogs/no-campaigns-modal/no-campaigns-modal.component';
import {NzCollapseModule} from "ng-zorro-antd/collapse";
import { UpdateUserRoleComponent } from './components/update-user-role/update-user-role.component';
import { QrCodeManagerComponent } from './qr-code-manager/qr-code-manager.component';
import { QrcodeFormComponent } from './components/qrcode-form/qrcode-form.component';
import { MapPinSelectorComponent } from './components/map-pin-selector/map-pin-selector.component';
import { QrEnlargeComponent } from './components/qr-enlarge/qr-enlarge.component';
import { SharedLinkPipe } from './pipes/shared-link.pipe';

FullCalendarModule.registerPlugins([ // register FullCalendar plugins
  dayGridPlugin,
  timeGridPlugin,
  interactionPlugin
]);

const imports: any = [
  FullCalendarModule,
  MatDialogModule,

  DropdownMenusModule,
  FormsModule,
  ReactiveFormsModule,
  NzPaginationModule,
  GoogleMapsModule,
  NzModalModule,
  NzUploadModule,
  NzIconModule,
  NzTimePickerModule,
  NzDatePickerModule,
  NzSelectModule,
  NzSwitchModule,
  NzAffixModule,
  DataTablesModule,
  NzBreadCrumbModule,
  NzRadioModule,
  ColorSketchModule,
  ClipboardModule,
  NzNotificationModule,
  NgxStripeModule,
  CalendarModule,
  NzImageModule,
  NzSliderModule,
  NzPopoverModule,
  NzAutocompleteModule,
  NzAnchorModule,
  NgApexchartsModule,
  NzToolTipModule,
  SwiperModule,
  TimeagoModule,
  AngularEditorModule,
  RouterModule,
  NzDrawerModule,
  NzCollapseModule
];

const components: any = [
  PaymentDialogComponent,
  UpdateUserCredentialsComponent,
  CreateUserComponent,
  CardLoaderComponent,
  ConfirmationModalComponent,
  AddressFormComponent,
  ErrorMessageModalComponent,
  UpdatePaymentModalComponent,
  ChangePasswordModalComponent,
  ProvideFeedbackModalComponent,
  CalendarModalComponent,
  FileUploaderComponent,
  SocialNetworkListComponent,
  InlineFileUploadComponent,
  AutomaticFileUploadComponent,
  BrandSelectorComponent,
  SearchBrandComponent,
  NumberFormatPipe,
  ConfigureEmailModalComponent,
  CopyButtonComponent,
  MyProfileComponent,
  ReportGeoChartComponent,
  ReportAgeChartComponent,
  LargeFileUploader,
  WelcomeModalComponent,
  WelcomeWidgetComponent,
  FancyCheckboxComponent,
  DonationTableComponent,
  ActivityGraphComponent,
  HeatMapComponent,
  DonorTableComponent,
  QrCodeManagerComponent,
  MapPinSelectorComponent
];

@NgModule({
  schemas: [ CUSTOM_ELEMENTS_SCHEMA ],
    declarations: [
        ...components,
        EndTrialModalComponent,
        SearchFiltersComponent,
        NoCampaignsModalComponent,
        UpdateUserRoleComponent,
        QrcodeFormComponent,
        QrEnlargeComponent,
        SharedLinkPipe
    ],
  imports: [
    CommonModule, ...imports, LineTruncationLibModule, BsDatepickerModule, NzSpinModule
  ],
  exports: [
    ...components, ...imports, LineTruncationDirective, NumberFormatPipe, QrCodeManagerComponent, SharedLinkPipe
  ]
})
export class SharedModule { }
